import { render, staticRenderFns } from "./BotIntent.vue?vue&type=template&id=4362d80c"
import script from "./BotIntent.vue?vue&type=script&lang=js"
export * from "./BotIntent.vue?vue&type=script&lang=js"
import style0 from "./BotIntent.vue?vue&type=style&index=0&id=4362d80c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports